
export enum SoundNames {
    wheel_button_press = "wheel_button_press",
    wheel_entry = "wheel_entry",
    wheel_exit = "wheel_exit",
    wheel_lose = "wheel_lose",
    wheel_spin = "wheel_spin",
    wheel_win = "wheel_win",
    bigwin = "bigwin",
    faf_boxingglove_punchfox = "faf_boxingglove_punchfox",
    faf_boxingglove_shove = "faf_boxingglove_shove",
    faf_chickenegg_fall = "faf_chickenegg_fall",
    faf_chickenegg_impactfloor = "faf_chickenegg_impactfloor",
    faf_chickenperched_flee = "faf_chickenperched_flee",
    faf_chickenperched_selected = "faf_chickenperched_selected",
    faf_chicken_win = "faf_chicken_win",
    faf_coup_rattle = "faf_coup_rattle",
    faf_fowlplay_ui_rise = "faf_fowlplay_ui_rise",
    faf_fox_dazed = "faf_fox_dazed",
    faf_fox_flying_getshelmet = "faf_fox_flying_getshelmet",
    faf_fox_flying_impactduck = "faf_fox_flying_impactduck",
    faf_fox_flying_impactpig = "faf_fox_flying_impactpig",
    faf_fox_flying_spinning_loop = "faf_fox_flying_spinning_loop",
    faf_fox_flying_spinning_v2a_loop = "faf_fox_flying_spinning_v2a_loop",
    faf_fox_flying_spinning_v2b_loop = "faf_fox_flying_spinning_v2b_loop",
    faf_fox_flying_spinning_v2c_loop = "faf_fox_flying_spinning_v2c_loop",
    faf_fox_flying_spinning_v2d_loop = "faf_fox_flying_spinning_v2d_loop",
    faf_fox_footstep_1 = "faf_fox_footstep_1",
    faf_fox_footstep_2 = "faf_fox_footstep_2",
    faf_fox_footstep_3 = "faf_fox_footstep_3",
    faf_fox_footstep_4 = "faf_fox_footstep_4",
    faf_fox_grabbed = "faf_fox_grabbed",
    faf_fox_hehehe = "faf_fox_hehehe",
    faf_fox_impactground_1 = "faf_fox_impactground_1",
    faf_fox_impactground_2 = "faf_fox_impactground_2",
    faf_fox_impactground_3 = "faf_fox_impactground_3",
    faf_fox_impactground_4 = "faf_fox_impactground_4",
    faf_fox_impactground_5 = "faf_fox_impactground_5",
    faf_fox_launched = "faf_fox_launched",
    faf_fox_pulled = "faf_fox_pulled",
    faf_fox_spin = "faf_fox_spin",
    faf_gemegg_twinkle = "faf_gemegg_twinkle",
    fpg_bonus_bgTune = "fpg_bonus_bgTune",
    fpg_bonus_shortOutroTune = "fpg_bonus_shortOutroTune",
    fpg_chickenLayEgg = "fpg_chickenLayEgg",
    fpg_fanfare = "fpg_fanfare",
    fpg_looney = "fpg_looney",
    fpm_ambience_loop = "fpm_ambience_loop",
    fpm_bg_BanjoDitty = "fpm_bg_BanjoDitty",
    fpm_bg_GeeseFlying = "fpm_bg_GeeseFlying",
    fpm_bg_TractorDrive = "fpm_bg_TractorDrive",
    fpm_music_FreeSpins_Loop_HighEnergy = "fpm_music_FreeSpins_Loop_HighEnergy",
    fpm_music_FreeSpins_Loop_LowEnergy = "fpm_music_FreeSpins_Loop_LowEnergy",
    fpm_sfx_bonus_ChickenChatter = "fpm_sfx_bonus_ChickenChatter",
    fpm_sfx_bonus_ChickenChatterLoop = "fpm_sfx_bonus_ChickenChatterLoop",
    fpm_sfx_bonus_Cluck = "fpm_sfx_bonus_Cluck",
    fpm_sfx_DealMysterySymbolsLoop = "fpm_sfx_DealMysterySymbolsLoop",
    fpm_sfx_Kerching = "fpm_sfx_Kerching",
    fp_anticipation_1 = "fp_anticipation_1",
    fp_anticipation_2 = "fp_anticipation_2",
    fp_anticipation_3 = "fp_anticipation_3",
    fp_bet_value_decrease = "fp_bet_value_decrease",
    fp_bet_value_increase = "fp_bet_value_increase",
    fp_board_appears = "fp_board_appears",
    fp_dab_1 = "fp_dab_1",
    fp_dab_2 = "fp_dab_2",
    fp_dab_3 = "fp_dab_3",
    fp_dab_4 = "fp_dab_4",
    fp_dab_5 = "fp_dab_5",
    fp_extra_spin_click = "fp_extra_spin_click",
    fp_free_spin_added = "fp_free_spin_added",
    fp_free_spin_whoosh = "fp_free_spin_whoosh",
    fp_free_spin_whoosh_v2 = "fp_free_spin_whoosh_v2",
    fp_launch_game = "fp_launch_game",
    fp_level_up_cashPrize = "fp_level_up_cashPrize",
    fp_level_up_featurePrize = "fp_level_up_featurePrize",
    fp_level_up_noPrize = "fp_level_up_noPrize",
    fp_misc_yeehaa = "fp_misc_yeehaa",
    fp_Prize_countup_loop = "fp_Prize_countup_loop",
    fp_reels_lightsweep_backward = "fp_reels_lightsweep_backward",
    fp_reels_lightsweep_forward = "fp_reels_lightsweep_forward",
    fp_reel_drop_superwild_v3 = "fp_reel_drop_superwild_v3",
    fp_reel_drop_wild_v3 = "fp_reel_drop_wild_v3",
    fp_reel_stop_1 = "fp_reel_stop_1",
    fp_reel_stop_2 = "fp_reel_stop_2",
    fp_reel_stop_3 = "fp_reel_stop_3",
    fp_reel_stop_4 = "fp_reel_stop_4",
    fp_reel_stop_5 = "fp_reel_stop_5",
    fp_slingo_1 = "fp_slingo_1",
    fp_slingo_2 = "fp_slingo_2",
    fp_slingo_3 = "fp_slingo_3",
    fp_slingo_4 = "fp_slingo_4",
    fp_spin_click = "fp_spin_click",
    fp_spin_loop = "fp_spin_loop",
    fp_theme1_loop = "fp_theme1_loop",
    fp_theme2_loop = "fp_theme2_loop",
    fp_theme3_loop = "fp_theme3_loop",
    fp_trans_to_pick = "fp_trans_to_pick",
    fp_trans_to_slot = "fp_trans_to_slot",
    fp_you_could_win_text = "fp_you_could_win_text",
    reelspin = "reelspin",
    reelstop = "reelstop",
    rp_banjoriff_1 = "rp_banjoriff_1",
    rp_ip_bigwin_edit = "rp_ip_bigwin_edit",
    rp_snarerollgong = "rp_snarerollgong",
    rp_win_fullhouse = "rp_win_fullhouse",
    rp_win_itemsemit = "rp_win_itemsemit",
    rp_win_totalwin = "rp_win_totalwin"
}
